import React, { useState } from "react";
import SingleAccord from "./SingleAccord";

import "./Accordian.scss";

export interface Props {
  title: any[];
  content: any[];
  style?: React.CSSProperties;
  btnStyle?: React.CSSProperties;
  contentStyle?: React.CSSProperties;
  btnClass?: string;
  contentClass?: string;
}

const Accordian = ({ title, content, style, btnStyle, contentStyle, btnClass, contentClass }: Props) => {
  const [currentIdx, setCurrentIdx] = useState(0);
  const btnOnClick = (idx: number) => {
    setCurrentIdx((currentValue) => (currentValue !== idx ? idx : -1));
  };
  return (
    <ul className="mfg-accordion">
      {title?.map((item: any, idx: any) => (
        <SingleAccord
          key={idx}
          title={title[idx]}
          content={content[idx]}
          isOpen={idx === currentIdx}
          btnOnClick={() => btnOnClick(idx)}
          style={style && style}
          btnStyle={btnStyle && btnStyle}
          contentStyle={contentStyle && contentStyle}
          btnClass={btnClass && btnClass}
          contentClass={contentClass && contentClass}
        />
      ))}
    </ul>
  );
};

export default Accordian;
